import { validate as isUuid } from 'uuid';

import {
	createEditableTable,
	getEditableTables,
	updateTable,
	getEditableTable,
} from '../../actions/editableTableActions';

export const RECEIVE_EDITABLE_TABLES = 'receive_editable_tables';
export const REQUEST_EDITABLE_TABLES = 'request_editable_tables';
export const EDITABLE_TABLES_ERROR = 'editable_tables_error';

// got never implemented. philipp prob thought that its enough when they get deleted on project deletion which is fine for now
export const RECEIVE_DELETE_EDITABLE_TABLE = 'receive_delete_editable_table';
export const REQUEST_DELETE_EDITABLE_TABLE = 'request_delete_editable_table';
export const DELETE_EDITABLE_TABLE_ERROR = 'delete_editable_table_errror';

// these are only local changes
export const UPDATE_EDITABLE_TABLE_DATA = 'update_editable_table_data';
export const RECEIVE_ADD_EDITABLE_TABLE = 'receive_add_editable_table';

// store local changes in db
export const RECEIVE_SAVE_EDITABLE_TABLE = 'receive_save_editable_table';
export const REQUEST_SAVE_EDITABLE_TABLE = 'request_save_editable_table';
export const ERROR_SAVE_EDITABLE_TABLE = 'error_save_editable_table';

const getEditableTablesRedux = () => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_EDITABLE_TABLES,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_EDITABLE_TABLES,
			payload: success,
		});
		return success;
	};

	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: EDITABLE_TABLES_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call

		const { tables } = await getEditableTables();
		return onSuccess(tables);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const createEditableTableRedux = (newEditableTable) => async (dispatch) => {
	// only local change
	dispatch({
		type: RECEIVE_ADD_EDITABLE_TABLE,
		payload: newEditableTable,
	});
};

const updateEditableTableDataRedux = (tableId, tableData) => async (dispatch) => {
	// only local change
	dispatch({
		type: UPDATE_EDITABLE_TABLE_DATA,
		payload: { ...tableData, _id: tableId },
	});
};

const saveEditableTableChangesRedux = (localchanges) => async (dispatch) => {
	const onRequest = () => {
		// dipatch request string to be handled by reducer
		dispatch({
			type: REQUEST_SAVE_EDITABLE_TABLE,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dipatch receive string and payload to be handled by reducer
			type: RECEIVE_SAVE_EDITABLE_TABLE,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dipatch error string and payload to be handled by reducer
			type: ERROR_SAVE_EDITABLE_TABLE,
			payload: error,
		});
	};
	try {
		onRequest();

		const success = [];

		// go through all changes and handle them
		for (const change of localchanges) {
			// in that case we have to add the
			if (isUuid(change._id)) {
				delete change._id;
				const response = await createEditableTable(change);
				const { createdEditableTable } = response;
				success.push(createdEditableTable);
			} else {
				const response = await updateTable(change._id, change);
				const { updatedTable } = response;
				success.push(updatedTable);
			}
		}
		onSuccess(success);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

export {
	createEditableTableRedux,
	getEditableTablesRedux,
	updateEditableTableDataRedux,
	saveEditableTableChangesRedux,
};
